import { PayloadAction } from '@reduxjs/toolkit';
import { Pagination } from 'app/interfaces';
import { PaginatedApiEntitiesState } from 'app/interfaces/store';

export const updatePaginationReducer = <T extends PaginatedApiEntitiesState<unknown, unknown>>(
  state: T,
  action: PayloadAction<{ data: Partial<Pagination> }>
) => {
  return {
    ...state,
    limit: action.payload.data.limit ?? state.limit,
    offset: action.payload.data.offset ?? state.offset,
  };
};
